<template>
  <!-- 解答题 -->
  <div
    class="fill-topic topic-box"
    @mouseleave="showTopicEditorBox = false"
    @mouseenter="handleMouseEnter"
    :style="msg.currentIndexInPage == 0 ? `` : ''"
  >
    <!-- <div
      v-for="(group, index) in msg.htmlArray"
      class="answer-group answer-topic topic-box"
      :key="'group' + index"
      @click.stop.prevent="editBox(index)"
    >-->
    <div class="topic-th" v-if="msg.hasTitle">
      <EditScoreBox
        :msg="msg"
        @myBlur="handlerBlur"
        :isPreview="isPreview"
      ></EditScoreBox>
    </div>
    <div v-else>
      <EditScoreBox
        :msg="msg"
        @myBlur="handlerBlur"
        :isPreview="isPreview"
      ></EditScoreBox>
    </div>
    <div
      class="topic-bd fill-cont answer-cont"
      :data-th="setData"
      :style="{
        border: showTopicEditorBox ? '1px solid #409eff !important' : '',
        height: msg.initDragHeight + 'px',
      }"
    >
      <TopicEditBox
        v-if="showTopicEditorBox"
        position="top:5px"
        :msg="msg"
      ></TopicEditBox>
      <div class="drag_mark" v-show="showTopicEditorBox"></div>

      <template v-if="isPreview">
        <div class="ck-content" v-html="html"></div>
        <!-- <code>{{ msg.innerHTML }}</code> -->
      </template>
      <template v-if="!isPreview">
        <!-- <ckeditor :editor="editor" v-model="msg.innerHTML" :config="editorConfig"></ckeditor> -->
        <MyUEditor
          :msg="msg"
          @onMouseEnter="showTopicEditorBox = false"
          @onBlur="handleBlur"
        ></MyUEditor>
      </template>
      <div class="drag_button" id="drag_button" v-show="showTopicEditorBox">
        <i class="el-icon-rank" style="font-size: 22px"></i>
      </div>
      <!--主体-->
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from "vuex";
import { mouseEventMixins } from "../../mixins/mouseEvent.mixins";
import { MARGIN_BOTTOM, TAG_P_HEIGHT } from "@/subjects/constant";
import CustomEditBox from "@/components/TopicMakeBox/CustomEditBox";
import FillTopic from "@/assets/js/utils/FillTopic";
import MyDrag from "@/assets/js/utils/base/MyDrag";
import { editScoreBoxMixins } from "../../mixins/editScoreBox.mixins";
// import ClassicEditor from "@ckeditor/ckeditor5-build-inline";
//import JQ from "jquery";
export default {
  name: "fillTopic",
  props: {
    msg: { innerHTML: "" },
    topic: Object,
    isPreview: Boolean,
  },
  mixins: [mouseEventMixins, editScoreBoxMixins],
  components: {
    CustomEditBox,
  },
  computed: {
    ...mapState("card", {
      answerSignal: (state) => state.answerSignal,
      subjects: (state) => state.subjects,
      existHeight: (state) => state.existHeight,
      pageCell: (state) => state.pageCell,
      currentPageNum: (state) => state.currentPageNum,
      newTopicHeight: (state) => state.newTopicHeight,
    }),
    html: function () {
      return this.msg.innerHTML
    },
    setData: function () {
      const chineseNumMap = { 
        '一': 1, '二': 2, '三': 3,'四': 4,'五': 5,'六':6,'七':7,'八':8,'九':9,'十':10 ,
        '十一':11,'十二':12,'十三':13,'十四':14,'十五':15,'十六':16,'十七':17,'十八':18,'十九':19,'二十':20,
        '二十一':21,'二十二':22,'二十三':23,'二十四':24,'二十五':25,'二十六':26,'二十七':27,'二十八':28,'二十九':29,'三十':30 
      };
      const th = chineseNumMap[this.msg.th];
      return th + '.' + this.msg.no;
    },
    
  },
  data() {
    return {
      showTopicEditorBox: false,
      myFillTopic: undefined,
      myDrag: undefined,
      editorData: "",
      editor: null,
    };
  },
  created() {
    // this.editor = this.$ckEditor;
  },
  mounted() {
    this.initDrag();

    // setTimeout(() => {
    //   if (this.answerSignal) {
    //     console.log(
    //       "看看this.currentPage",
    //       this.pageCell[this.pageCell.length - 1].fillTopiclist
    //     );
    //     if (this.isPreview) {
    //       myFillTopic.recursionCutAnswerPage = null;
    //     }
    //     myFillTopic.recursionCutAnswerPage(
    //       this.pageCell.length - 1,
    //       this.existHeight,
    //       undefined,
    //       false
    //     );
    //     this.setAnswerSignal(false);
    //   }
    // }, 200);
  },
  methods: {
    ...mapMutations({
      setAnswerSignal: "card/setAnswerSignal",
      setCurrentPageNum: "card/setCurrentPageNum",
      updatePageCell: "card/updatePageCell",
      updateSubjects: "card/updateSubjects",
    }),
    fontStyle(isWindows) {
      return isWindows ? 
        'font-family: "Courier New",monospace; letter-spacing:-0.15em' : 
        'font-family: "SF Mono",monospace;';
    },
    createSpaces(isWindows) {
      // Windows需要更多空格补偿渲染差异
      return isWindows ? 
        '(&nbsp;'.repeat(12) + ')' : 
        '(&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;)';
    },
    async handleBlur(data) {
      let subjectsIdx = undefined;
      const { editorHeight, content, overstepDistance } = data;
      // this.subjects.forEach((subject, index) => {
      //   if ((this.msg.th = subject.th)) {
      //     subject.innerHTML = content;
      //   }
      // });
      this.setCurrentPageNum(this.msg.pageIndex);
      await this.updatePageCell({
        currentIndexInPage: this.msg.currentIndexInPage,
        initDragHeight: editorHeight,
        innerHTML: content,
      });
      try {
       this.deconstruction();
      } catch (error) {
        console.error('编辑器失焦析构解答题报错', error.message);
      }
      const timer = setTimeout(() => {
        overstepDistance > 0 &&
          this.myFillTopic.updateViewHeight(
            overstepDistance,
            undefined,
            undefined,
            "blur"
          );
        clearTimeout(timer);
      }, 200);
    },
    /**
     * Deconstruction 析构 相当于把拆解的题型重新复合
     */
    deconstruction() {
     const timerUpdate = setTimeout(() => {
        // 这里最好使用异步的方法处理 不影响其他代码的执行
        // 在这里处理自定义编辑的问题 blur的时候把高度 html存储到subjects里面去
        // 记录当前编辑的subject下标 循环的时候把使用下标让上面的题型保持不变 下面的题型重新appendToPage
        let sameTopicList = []; // 把整个页面的pagecell的filltopiclist中属于该题号的题型stack存起来
        const copyPageCell = JSON.parse(JSON.stringify(this.pageCell));
        copyPageCell.forEach((page) => {
          page.fillTopiclist.forEach((topic) => {
            if (topic.th == this.msg.th) {
              sameTopicList.push(topic);
            }
          });
        });
        let subjectContainer = { initDragHeight: 0, innerHTML: "" }; // 用来存储html和高度
        this.subjects.forEach(async (subject, index) => {
          if (subject.th == this.msg.th) {
            // 题号相等的说明属于该题型的分解 然后记录下该下标
            sameTopicList.forEach((sameTopic) => {
              subjectContainer.initDragHeight += sameTopic.initDragHeight || 0; //给subject对象赋予高度
              subjectContainer.innerHTML += sameTopic.innerHTML || "";
            });
            console.log('deconstruction===========log');
            subject.setHtml(subjectContainer.innerHTML);
            subject.setInitDragHeight(subjectContainer.initDragHeight);
            let result = [];
            const map = {}; //用来存储合并之后的数据
            sameTopicList.forEach((sameTopic, sameTopicIndex) => {
              // 合并分解的题型 还原到subjects里面去
             
              // 这里是因为改成小题号模式之后出现 需要做对应的更新 （就是将加答题拖拽分解的高度，htmk合并到同一个题号中的同一个小题号）
              // if (sameTopicList[sameTopicIndex]) {
              //   if (sameTopicList[sameTopicIndex].no == (sameTopicList[sameTopicIndex + 1] && sameTopicList[sameTopicIndex + 1].no) && (sameTopicList[sameTopicIndex + 1] && sameTopicList[sameTopicIndex + 1].xth) == sameTopicList[sameTopicIndex].xth) {
              //     result.push({
              //       ...sameTopicList[sameTopicIndex + 1],
              //      initDragHeight: sameTopicList[sameTopicIndex].initDragHeight + sameTopicList[sameTopicIndex + 1].initDragHeight,
              //      innerHTML: sameTopicList[sameTopicIndex].innerHTML + sameTopicList[sameTopicIndex + 1].innerHTML,
              //    });
              //   } else {
              //       if(
              //     (sameTopicList[sameTopicIndex-1] && sameTopicList[sameTopicIndex].xth && (sameTopicList[sameTopicIndex].xth == sameTopicList[sameTopicIndex-1].xth))
              //        ) {
              //      } else if(sameTopicList[sameTopicIndex-1] && ! (sameTopicList[sameTopicIndex].xth) && (sameTopicList[sameTopicIndex].no == sameTopicList[sameTopicIndex-1].no)) {
              //     } else {
              //       result.push(sameTopicList[sameTopicIndex]);
              //     }
              //   }
              // }
              // 新方法 数组对象根据某个key相同合并分组
              // for(var i = 0; i < arr.length; i++){
                // var ai = arr[i];
                if (sameTopicList[sameTopicIndex]) {
                if(!map[sameTopic.no + '-' + sameTopic.xth]){
                  result.push(sameTopic);
                  map[sameTopic.no + '-' + sameTopic.xth] = sameTopic;
                } else{
                  for(var j = 0; j < result.length; j++){
                    var nextsameTopic = result[j];
                      if(nextsameTopic.xth && (nextsameTopic.no == sameTopic.no) && (nextsameTopic.xth == sameTopic.xth)){
                        nextsameTopic.initDragHeight += sameTopic.initDragHeight -MARGIN_BOTTOM;
                        nextsameTopic.innerHTML += sameTopic.innerHTML;
                        break;
                      } else if (!nextsameTopic.xth &&(nextsameTopic.no == sameTopic.no)) {
                        nextsameTopic.initDragHeight += sameTopic.initDragHeight -MARGIN_BOTTOM;
                        nextsameTopic.innerHTML += sameTopic.innerHTML;
                        break;
                    }
                  }
                }
                }
              // }
            });
            // Object.keys(map).forEach((key) => {
            //   result.push(map[key]);
            // }); // 拿到合并的数组之后 然后再set到对象的htmlArray中去
            subject.setHtmlArray(result);
            subject.setFromEdit(false);
            await this.updateSubjects({
              index: index,
              data: subject,
            });
          }
        });
        clearTimeout(timerUpdate);
      }, 100);
    },
    initDrag() {
      const target = document.querySelectorAll(".topic-bd");
      this.myDrag = new MyDrag(target);
      this.myFillTopic = new FillTopic({
        width: 1107,
        height: 706,
        canDrag: true,
        myDrag: this.myDrag,
      });
      this.myFillTopic.init();
    },
  },
  watch: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.answer-cont {
  position: relative;
  box-sizing: border-box;
  overflow: hidden;
  // padding: 0 15px 20px;
  padding-bottom: 20px;
  border: 1px solid #aaa;
}

.answer-cont .ck-content p,
.answer-cont .ck-content.ck-editor__editable_inline > :first-child {
  margin-top: 10px !important;
}
.answer-cont {
  p {
    margin-top: 39px; //15+39=TAG_P_HEIGHT
  }
}
.cx-editor {
  pointer-events: none;
}
.topic-box {
  // border: 1px solid #000;
  .drag_button {
    display: none;
    position: absolute;
    bottom: 6px;
    right: 6px;
    z-index: 222222;
    pointer-events: none;
    .el-icon-rank {
      display: block;
      color: #409eff;
      cursor: n-resize;
    }
    .drag_i_active {
    }
  }
  .drag_mark {
    position: absolute;
    bottom: -30px;
    right: -30px;
    width: 80px;
    height: 80px;
    z-index: 222222;
    cursor: row-resize;
  }
  .drag_button:hover {
  }
}
.topic-box:hover .drag_button {
  display: block;
}
.topic-box:hover .topic-bd {
}

.row {
  font-family: Menlo, Monaco, monospace !important;
}

</style>
